var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#888888",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.4 6.39999H21.6L26.08 12.3733C26.2877 12.6503 26.4173 12.9917 26.3482 13.3309C25.8069 15.9889 21.2 15.812 21.2 12.8C21.2 16 16 16 16 12.8C16 16 10.8 16 10.8 12.8C10.8 15.812 6.19307 15.9889 5.65172 13.3309C5.58263 12.9917 5.71226 12.6503 5.91998 12.3733L10.4 6.39999Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.1937V23.2C8 23.6418 8.35817 24 8.8 24H23.2C23.6418 24 24 23.6418 24 23.2V15.1937C22.6369 15.28 21.2 14.4821 21.2 12.8C21.2 16 16 16 16 12.8C16 16 10.8 16 10.8 12.8C10.8 14.4821 9.36312 15.28 8 15.1937ZM13.6 17.6C13.6 17.1582 13.9582 16.8 14.4 16.8H17.6C18.0418 16.8 18.4 17.1582 18.4 17.6V23.2H13.6V17.6Z",
    fill: "#888888"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLogo);
export default __webpack_public_path__ + "static/media/placeholderLogo.e896374d58bc500d87bdc56d165b4613.svg";
export { ForwardRef as ReactComponent };